import { ExcludedDomains, ExcludedEmails } from "../constants/emails"
import { isProduction } from "./general"

const hasExcludedDomain = (email: string) => {
  const domain = email?.split("@")[1]
  if (!domain) return false
  return ExcludedDomains.some((excludedDomain) =>
    domain.endsWith(excludedDomain),
  )
}

export const isExcludedEmail = (email: string) => {
  if (!isProduction) return false
  const normalizedEmail = email.toLowerCase()
  return (
    hasExcludedDomain(normalizedEmail) ||
    ExcludedEmails.includes(normalizedEmail)
  )
}
